import { render, staticRenderFns } from "./DepositInfo.vue?vue&type=template&id=233e0858"
import script from "./DepositInfo.vue?vue&type=script&lang=js"
export * from "./DepositInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports